<template>
<div data-app>
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" :title="generaTitulo" class="elevation-1 px-5 py-3" >
                    <v-card-text>

                        <form-wizard v-if="editando==false" ref="wizard" @on-complete="onComplete" @on-change="onChange" :color="bg" error-color="#a94442" title subtitle nextButtonText="Siguiente" backButtonText="Anterior" finishButtonText="Finalizar" stepSize="xs" activateAll>
                            <tab-content title="Tráfico" icon="fa fa-calendar" :before-change="saveDatosGenerales" >
                                <div id="datos_generales" >
                                    <v-datos-generales-component v-if="active_tab==0" ref="datos_generales" @nextTab="nextTab" />
                                </div>
                            </tab-content>
                            <tab-content title="Detalle de Carga" icon="fa fa-barcode" :before-change="saveDetalleCarga" >
                                <v-detalle-carga-component v-if="active_tab==1" ref="detalle_carga" @nextTab="nextTab" />
                            </tab-content>
                            <tab-content title="Especificaciones de Embarque" icon="fa fa-list" :before-change="saveEmbarques" >
                                <v-trafico-embarque v-if="active_tab==2" ref="embarques" @nextTab="nextTab" ></v-trafico-embarque>
                            </tab-content>
                            <tab-content title="Transporte Nacional" icon="fa fa-truck" :before-change="saveTransportes" >
                                <v-trafico-transporte v-if="active_tab==3" ref="transportes" @nextTab="nextTab" ></v-trafico-transporte>
                            </tab-content>
                            <tab-content title="Alertas y Notificaciones" icon="fa fa-bell" :before-change="saveDetalleAlertas" >
                                <v-alertas-transporte v-if="active_tab==4" ref="detalle_alertas" @nextTab="nextTab" />
                            </tab-content>
                            <tab-content title="Facturas" icon="fa fa-qrcode" :before-change="saveDetalleFacturas" >
                                <v-detalle-facturas-component v-if="active_tab==5" ref="detalle_facturas" @nextTab="nextTab" />
                            </tab-content>
                            <tab-content title="Incrementables" icon="fa fa-plus" >
                                <v-detalle-incrementables-component v-if="active_tab==6" ref="detalle_incrementables" @nextTab="nextTab" />
                            </tab-content>
                        </form-wizard>

                        <v-tabs v-if="editando" fixed-tabs v-model="tabs" >
                            <v-tab key="mt1" @click.native="active_tab=0" > Tráfico </v-tab>
                            <v-tab key="mt2" @click.native="active_tab=1" > Detalle de Carga</v-tab>
                            <v-tab key="mt3" @click.native="active_tab=2" > Especificaciones de Embarque </v-tab>
                            <v-tab key="mt4" @click.native="active_tab=3" > Transporte Nacional </v-tab>
                            <v-tab key="mt5" @click.native="active_tab=4" > Alertas y Notificaciones </v-tab>
                            <v-tab key="mt6" @click.native="active_tab=5" > Facturas </v-tab>
                            <v-tab key="mt7" @click.native="active_tab=6" > Incrementables </v-tab>

                        </v-tabs>
                        <v-tabs-items v-if="editando" v-model="tabs" ref="wizard" >
                            <v-tab-item>
                                <v-flex xs12 md12 pa-5>
                                    <div id="datos_generales" >
                                        <v-datos-generales-component v-if="active_tab==0" ref="datos_generales" @nextTab="nextTab" />
                                    </div>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        
                                        <v-btn color="success" @click.native="saveDatosGenerales" >
                                            <v-icon>done</v-icon>Actualizar
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-tab-item>
                            <v-tab-item>
                                <v-flex xs12 md12 pa-5>
                                    <v-detalle-carga-component v-if="active_tab==1" ref="detalle_carga" @nextTab="nextTab" />
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        
                                        <v-btn color="success" @click.native="saveDetalleCarga" >
                                            <v-icon>done</v-icon>Actualizar
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-tab-item>
                            <v-tab-item>
                                <v-flex xs12 md12 pa-5>
                                    <v-trafico-embarque v-if="active_tab==2" ref="embarques" @nextTab="nextTab" ></v-trafico-embarque>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        
                                        <v-btn color="success" @click.native="saveEmbarques" >
                                            <v-icon>done</v-icon>Actualizar
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-tab-item>
                            <v-tab-item>
                                <v-flex xs12 md12 pa-5>
                                    <v-trafico-transporte v-if="active_tab==3" ref="transportes" @nextTab="nextTab" ></v-trafico-transporte>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        
                                        <v-btn color="success" @click.native="saveTransportes" >
                                            <v-icon>done</v-icon>Actualizar
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-tab-item>
                            <v-tab-item>
                                <v-flex xs12 md12 pa-5>
                                    <v-alertas-transporte v-if="active_tab==4" ref="detalle_alertas" @nextTab="nextTab" />
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        
                                        <v-btn color="success" @click.native="saveDetalleAlertas" >
                                            <v-icon>done</v-icon>Actualizar
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-tab-item>
                            <v-tab-item>
                                <v-flex xs12 md12 pa-5>
                                    <v-detalle-facturas-component v-if="active_tab==5" ref="detalle_facturas" @nextTab="nextTab" />
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        
                                        <v-btn color="success" @click.native="saveDetalleFacturas" >
                                            <v-icon>done</v-icon>Actualizar
                                        </v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-tab-item>
                            <v-tab-item>
                                <v-flex xs12 md12 pa-5>
                                    <v-detalle-incrementables-component v-if="active_tab==6" ref="detalle_incrementables" @nextTab="nextTab" />
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        
                                        <v-btn color="success" @click.native="saveDetalleIncrementables" >
                                            <v-icon>done</v-icon>Actualizar
                                        </v-btn>
                                    </v-card-actions>
                                   
                                </v-flex>
                            </v-tab-item>

                        </v-tabs-items>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import datosGenerales from "@/components/trafico/DatosGenerales.vue";
import detalleCarga from "@/components/trafico/DetalleCarga.vue";
import traficoEmbarque from "@/components/trafico/Embarque.vue";
import traficoTransporte from "@/components/trafico/TransporteNacional.vue";
import alertasTransporte from "@/components/trafico/Notificaciones.vue";
import detalleFacturas from "@/components/trafico/DetalleFacturas.vue";
import detalleIncrementables from "@/components/trafico/DetalleIncrementables.vue";
import {
    FormWizard,
    TabContent
} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
    request
} from "http";
import {
    mapState
} from "vuex";

export default {
    components: {
        "vue-form-generator": VueFormGenerator.component,
        "v-datos-generales-component": datosGenerales,
        "v-trafico-embarque": traficoEmbarque,
        "v-detalle-carga-component": detalleCarga,
        "v-detalle-facturas-component": detalleFacturas,
        "v-detalle-incrementables-component": detalleIncrementables,
        "v-trafico-transporte": traficoTransporte,
        "v-alertas-transporte": alertasTransporte,
        FormWizard,
        TabContent
    },
    created() {
        this.$store.state.embarques_trafico = [];
        this.$store.state.transportes_trafico = [];
        this.$store.state.alertas_trafico = [];
    },
    mounted() {
        /*  if (this.$local_storage.get("update") == 'true') {
             var wizard = this.$refs.wizard
             wizard.maxStep = wizard.tabs.length - 1
             wizard.tabs.forEach((tab) => {
                 tab.checked = true
             })
         } */

    },
    beforeDestroy: function () {
        this.active_tab = -1; //Para que destruya todos los componentes al no cumplirse el v-if
    },
    computed: {
        editando() {

            return this.$local_storage.get("update") == 'true';
        },
        generaTitulo() {
            if (!this.editando)
                return "Registro de Nuevo Tráfico"
            else
                return "Editar Tráfico " + this.$local_storage.get("referencia");
        }
    },
    data() {
        return {
            tabs: null,
            fab: false,
            active_tab: 0,
            show_loading: false,
            breadcrumbs: [
                {
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Logística",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Registro",
                    disabled: true,
                    to: ""
                }
            ],
            bg: "#0E4D78",

            formOptions: {
                validationErrorClass: "has-error",
                validationSuccessClass: "has-success",
                validateAfterChanged: true
            }
        };
    },
    methods: {
        onComplete: function () {
            return new Promise((resolve, reject) => {
                this.$refs.detalle_incrementables.guardar(resolve);
            });
        },
        onChange: function (prevIndex, nextIndex) {
            this.active_tab = nextIndex;
        },

        saveDatosGenerales() {
            return new Promise((resolve, reject) => {
                if (this.$local_storage.get("update") == 'true')
                    this.$refs.datos_generales.update(resolve);
                else
                    this.$refs.datos_generales.save(resolve);
            });
        },
        saveDetalleCarga() {
            return new Promise((resolve, reject) => {
                this.$refs.detalle_carga.guardar(resolve);
            });

        },
        saveEmbarques() {
            return new Promise((resolve, reject) => {
                this.$refs.embarques.save(resolve);
            });

        },
        saveTransportes() {
            return new Promise((resolve, reject) => {
                this.$refs.transportes.save(resolve);
            });

        },

        saveDetalleAlertas() {
            return new Promise((resolve, reject) => {
                this.$refs.detalle_alertas.guardar(resolve);
            });
        },

        saveDetalleFacturas() {
            return new Promise((resolve, reject) => {
                this.$refs.detalle_facturas.guardar(resolve);
            });
        },
        saveDetalleIncrementables() {
            return new Promise((resolve, reject) => {
                this.$refs.detalle_incrementables.guardar(resolve);
            });
        },


        nextTab(tabs) {

            this.$refs.wizard.nextTab();
        }
    }
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small ;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small ;
    background-color: #CB6907;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
</style>
